import React, { useState } from 'react';
import { Grid, Column, Layer, Heading, Stack } from '@carbon/react';
import { MarketingVariant } from '../../routes/MarketingRouter';
import MarketingHeader from '../../components/marketing/MarketingHeader';
import MarketingFooter from '../../components/marketing/MarketingFooter';
import TrialSignupWizard from '../../components/marketing/TrialSignupWizard';
import styles from './TrialSignupPage.module.scss';

interface TrialSignupPageProps {
  variant?: MarketingVariant;
}

const TrialSignupPage: React.FC<TrialSignupPageProps> = ({ variant = 'default' }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const handleWizardComplete = () => {
    setShowSuccess(true);
  };

  if (showSuccess) {
    return (
      <div className={styles.pageContainer}>
        <MarketingHeader variant={variant} />
        <Layer>
          <Grid>
            <Column lg={16} md={8} sm={4}>
              <div className={styles.headerSection}>
                <Stack gap={6}>
                  <Heading className={styles.headerTitle}>Welcome to Sigma08!</Heading>
                  <p className={styles.headerSubtitle}>
                    Your trial account has been created. Check your email for login instructions and next steps.
                  </p>
                </Stack>
              </div>
            </Column>
          </Grid>
        </Layer>
        <MarketingFooter />
      </div>
    );
  }

  return (
    <div className={styles.pageContainer}>
      <MarketingHeader variant={variant} />

      <Layer>
        <Grid>
          <Column lg={16} md={8} sm={4}>
            <div className={styles.headerSection}>
              <Stack gap={6}>
                <Heading className={styles.headerTitle}>Start Your Free Trial</Heading>
                <p className={styles.headerSubtitle}>30 days free • No credit card required • Full access</p>
              </Stack>
            </div>
          </Column>
        </Grid>
      </Layer>

      <Layer>
        <Grid>
          <Column lg={16} md={8} sm={4}>
            <TrialSignupWizard onComplete={handleWizardComplete} source={`trial-signup-${variant}`} />
          </Column>
        </Grid>
      </Layer>
      <MarketingFooter />
    </div>
  );
};

export default TrialSignupPage;
